import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import React from "react";
import DiceCompanySettingForm from "./diceCompanySetting/DiceCompanySettingForm";
import DiceBranchSettingForm from "./diceBranchSetting/DiceBranchSettingForm";
import DiceTeamSettingForm from "./diceTeamSetting/DiceTeamSettingForm";
import DiceUserSettingForm from "./diceUserSetting/DiceUserSettingForm";
interface IProps {
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}
const Form = (props: IProps) => {
  const onHide = () => {
    props.hideDialog();
  };
  return (
    <>
      <Dialog style={{ width: "80vw" }} header="Add Template" className="p-fluid" modal visible={props.open} onHide={onHide} maximizable>
        <Accordion multiple activeIndex={[0]}>
          <AccordionTab header="Dice Company Wise Setting">
            <DiceCompanySettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
          <AccordionTab header="Dice Branch Wise Setting">
            <DiceBranchSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
          <AccordionTab header="Dice Team Wise Setting">
            <DiceTeamSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
          <AccordionTab header="Dice User Wise Setting">
            <DiceUserSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
        </Accordion>
      </Dialog>
    </>
  );
};

export default Form;
